/**
 * Módulo: Plataforma Operación
 * Grupo del sidebar — mitad "operativa" del split de la sección Plataforma
 * (7-jul-2026, Mariano). Debajo de Supervisión.
 *
 * Acá viven solo los ÍTEMS del menú; las rutas siguen en sus módulos de origen
 * (`plataforma/config.js` para Observabilidad/Debugging/Audit logs,
 * `comunicaciones/config.js` para Difusiones). Mismo patrón que Supervisión.
 */
export default {
  id: 'plataforma-operacion',
  nombre: 'Plataforma Operación',
  descripcion: 'Sección operativa de la plataforma',
  icono: 'activity',
  tipo: 'admin',
  version: '0.1.0',

  routes: [],

  // Orden definido por Mariano (7-jul; 29-oct: Roadmap arriba de Debugging, Observabilidad antes de La Guardia). "Tutoriales" vive acá (ruta en
  // tutoriales/config.js); "Difusiones" vino de comunicaciones/config.js.
  menuItems: [
    // La ruta sigue declarada en roadmap/config.js; acá vive sólo el ítem (una
    // sola declaración). Pedido de Mariano, 29-oct-2026: arriba de Debugging (el 28-oct lo había pedido debajo).
    { label: 'Roadmap de desarrollo', path: '/roadmap-desarrollo', icon: 'list', permisoModulo: 'roadmap' },
    // ⚠️ Gateado por `debugging`, no por `observabilidad` (corregido 7-ago-2026,
    // ADR 064 tramo 5). Estaba mal desde el split: `debugging` es un módulo del
    // catálogo con sus permisos (ver/crear/autorizar), y el
    // ítem se mostraba según OTRO módulo. Quien tenía `debugging.ver` sin
    // `observabilidad.ver` no veía la entrada; al revés, la veía y el callable
    // lo rechazaba. Efecto del fix: hay que tildar `debugging.ver` en /permisos
    // para los roles que deban verlo (Wizard ve todo el catálogo igual).
    { label: '🐛 Debugging', path: '/debugging', icon: 'activity', permisoModulo: 'debugging' },
    { label: 'Observabilidad', path: '/observabilidad', icon: 'activity', permisoModulo: 'observabilidad' },
    { label: '🌙 La Guardia', path: '/guardia', icon: 'moon', permisoModulo: 'debugging' },
    { label: 'Difusiones', path: '/difusiones', icon: 'radio', permisoModulo: 'difusiones' },
    { label: 'Tutoriales', path: '/tutoriales', icon: 'video', permisoModulo: 'tutoriales' },
    { label: 'Audit logs', path: '/audit-logs', icon: 'shield', permisoModulo: 'audit-logs' },
    // `permisoModulo` es el MISMO código que gatea el callable
    // `listarInstalacionesSelfService`. No es una coincidencia a cuidar a
    // mano: hay un test que cruza las dos mitades, porque el ítem de
    // Debugging estuvo un mes gateado por otro módulo y el resultado fue que
    // quien tenía el permiso no veía la entrada y quien la veía era rechazado.
    { label: 'Instalaciones Tienda Nube', path: '/instalaciones', icon: 'plug', permisoModulo: 'instalaciones' },
  ],

  features: [],

  // El grupo se muestra si el rol tiene 'ver' sobre alguno de estos
  // (o es Wizard, que ve todo el catálogo).
  permisoModulos: ['observabilidad', 'debugging', 'roadmap', 'audit-logs', 'difusiones', 'tutoriales', 'instalaciones'],

}
